/* ec-drawer.js — gedrag van de theme-native cart drawer (Lumeure/Prestige; basis Ellegems/Allure).
   Rendert uit /cart.js, dus wat je ziet is altijd wat Shopify daadwerkelijk
   in de winkelwagen heeft staan — inclusief kortingen die Shopify zelf toekent. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ecd]');
  if (!root) return;

  var overlay = document.querySelector('[data-ecd-overlay]');
  // Taal-/marktpad (/pl/, /fr-fr/ …). Zonder dit vraagt de drawer cart.js in de
  // standaardtaal op en ziet een Poolse klant Nederlandse producttitels.
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfgEl = document.querySelector('[data-ecd-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }

  var TIERS = parseTiers(CFG.reward && CFG.reward.tiers);
  var upsellsLoaded = false;

  // Taal: Shopify's locale bepaalt de teksten; thema-instellingen winnen als ze gevuld zijn.
  var LOCALE = String(CFG.locale || (window.Shopify && Shopify.locale) || 'nl').slice(0, 2).toLowerCase();
  var I18N = (CFG.i18n && (CFG.i18n[LOCALE] || CFG.i18n.nl)) || {};
  // Trede-namen per taal (label onder de badge en {name} in de 'behaald'-tekst).
  if (I18N.tierNames) TIERS.forEach(function (tr, i) { if (I18N.tierNames[i]) tr.name = I18N.tierNames[i]; });
  function t(key, override) {
    // Een thema-instelling wint alleen als de eigenaar 'm ECHT zelf heeft aangepast.
    // De defaults zijn Nederlands; stond die check er niet, dan zou een Franse of
    // Poolse klant de Nederlandse standaardtekst zien omdat de instelling 'gevuld' is.
    if (override !== undefined && override !== null && String(override).trim() !== '') {
      var dutchDefault = (CFG.i18n && CFG.i18n.nl && CFG.i18n.nl[key]) || '';
      if (String(override).trim() !== String(dutchDefault).trim()) return override;
    }
    return I18N[key] || '';
  }

  // /cart.js levert GEEN compare_at_price en GEEN variantenlijst; allebei komen uit
  // /products/{handle}.js. We cachen het HELE product, want zowel de vanafprijs als
  // de maat/kleur-dropdown leest eruit — één fetch per product per sessie.
  var productCache = {};
  function loadProducts(cart) {
    var handles = [];
    cart.items.forEach(function (i) { if (handles.indexOf(i.handle) < 0) handles.push(i.handle); });
    var missing = handles.filter(function (h) { return !productCache[h]; });
    if (!missing.length) return Promise.resolve();
    return Promise.all(missing.map(function (h) {
      return fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.json(); })
        .then(function (p) { productCache[h] = p || {}; })
        // Faalt de fetch, dan cachen we een leeg product: geen vanafprijs en geen
        // dropdown, maar de regel zelf blijft gewoon werken.
        .catch(function () { productCache[h] = {}; });
    }));
  }
  function variantsFor(item) {
    var p = productCache[item.handle];
    return (p && p.variants) || [];
  }
  function compareAtFor(item) {
    var v = null;
    variantsFor(item).forEach(function (x) { if (x.id === item.variant_id) v = x; });
    var c = v && v.compare_at_price;
    return (c && Number(c) > item.original_price) ? Number(c) : null;
  }

  function parseTiers(raw) {
    // "2:15%:15% EXTRA KORTING, 3:20%:20% EXTRA KORTING"
    if (!raw) return [];
    return String(raw).split(',').map(function (chunk) {
      var p = chunk.split(':').map(function (s) { return s.trim(); });
      var min = parseInt(p[0], 10);
      if (!min) return null;
      return { min: min, name: p[1] || '', message: p[2] || p[1] || '' };
    }).filter(Boolean).sort(function (a, b) { return a.min - b.min; });
  }

  function money(cents) {
    // Allure verkoopt ook in PLN/GBP/USD (eigen markten). Shopify's shop.money_format
    // is altijd EUR, dus buiten de euro formatteren we zelf op de marktvaluta.
    var cur = CFG.currency || 'EUR';
    if (cur !== 'EUR' && window.Intl && Intl.NumberFormat) {
      // Notatie volgt de valuta zoals Essential die toonde: £54.99, $4.49, 259,99 zł.
      var tag = { GBP: 'en-GB', USD: 'en-US', PLN: 'pl-PL', AUD: 'en-AU', CAD: 'en-CA', NZD: 'en-NZ',
                  CHF: 'de-CH', CZK: 'cs-CZ', HUF: 'hu-HU', RON: 'ro-RO' }[cur] ||
                ({ nl: 'nl-NL', en: 'en-GB', fr: 'fr-FR', pl: 'pl-PL', de: 'de-DE', es: 'es-ES', it: 'it-IT',
                   cs: 'cs-CZ', hu: 'hu-HU', ro: 'ro-RO', sk: 'sk-SK' }[LOCALE] || 'nl-NL');
      try { return new Intl.NumberFormat(tag, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) {}
    }
    var fmt = CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    var amount = (cents / 100);
    var withComma = amount.toFixed(2).replace('.', ',');
    var withDot = amount.toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(amount)).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount)))
      .replace(/\{\{\s*amount\s*\}\}/g, withDot);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function el(sel) { return root.querySelector(sel); }

  // De upsell-knop volgt de variantkeuze in dezelfde kaart; zonder keuze de eerste variant.
  function selectedVariantFor(btn) {
    var card = btn.closest('.ecd-upsell-product');
    var sel = card && card.querySelector('[data-ecd-upsell-variant]');
    return (sel && sel.value) || btn.getAttribute('data-ecd-upsell-add');
  }

  // Statische teksten in de juiste taal zetten (thema-instelling wint als 'ie gevuld is).
  (function applyI18n() {
    // De thema-instelling staat al in de markup; die WINT. Alleen als 'ie leeg is
    // (of gelijk aan de nl-standaard) vullen we de vertaling in.
    var set = function (sel, key) {
      var e = el(sel); if (!e) return;
      var current = (e.textContent || '').trim();
      var dutchDefault = (CFG.i18n && CFG.i18n.nl && CFG.i18n.nl[key]) || '';
      var eigenTekst = current && current !== dutchDefault;
      if (eigenTekst) return;                 // eigenaar heeft 'm zelf gezet -> laten staan
      var val = I18N[key]; if (!val) return;
      e.textContent = val;
    };
    var titleEl = el('[data-ecd-title]');
    if (titleEl && I18N.title) {
      titleEl.innerHTML = esc(I18N.title) + ' <span data-ecd-count>' +
        (titleEl.querySelector('[data-ecd-count]') || { textContent: '0' }).textContent + '</span>';
    }
    set('.ecd-upsell-title', 'upsellTitle');
    set('.ecd-subtotal-label', 'subtotal');
    set('.ecd-discount-label', 'discount');
    set('.ecd-checkout', 'checkout');
    // aria-labels die in de markup staan
    root.querySelectorAll('[data-ecd-aria]').forEach(function (e) {
      var v = I18N[e.getAttribute('data-ecd-aria')];
      if (v) e.setAttribute('aria-label', v);
    });
    var closeBtn = el('[data-ecd-close]');
    if (closeBtn && I18N.ariaClose) closeBtn.setAttribute('aria-label', I18N.ariaClose);

    var ann = el('.ecd-announcement');
    if (ann && I18N.announcement && !ann.dataset.custom) ann.innerHTML = '<p>' + I18N.announcement + '</p>';
  })();

  // ── Openen / sluiten ──────────────────────────────────────────────
  var lastFocus = null;

  // De EA Sticky Cart-app gebruikt z-index 2147483647 — exact hetzelfde maximum als
  // wij (32-bit bovengrens, hoger kan niet). Bij een gelijkspel wint wie LATER in de
  // DOM staat, en EA hangt z'n paneel er pas bij het openen aan. Vandaar: bij elke
  // opening onze drawer naar het einde van <body> verplaatsen, zodat wij de laatste
  // zijn. Het element is position:fixed, dus verplaatsen verandert niets aan de lay-out.
  function bringToFront() {
    try {
      if (overlay) document.body.appendChild(overlay);
      document.body.appendChild(root);
    } catch (e) {}
  }

  function open() {
    lastFocus = document.activeElement;
    bringToFront();
    document.body.classList.add('ecd-open');
    root.hidden = false; if (overlay) overlay.hidden = false;
    // Geforceerde reflow i.p.v. requestAnimationFrame: rAF staat stil in een tab op de
    // achtergrond, en dan zou de drawer onzichtbaar 'open' blijven hangen.
    void root.offsetWidth;
    root.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    root.focus();
    refresh();
  }

  function close() {
    document.body.classList.remove('ecd-open');
    root.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      root.hidden = true; if (overlay) overlay.hidden = true;
    }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ── Renderen ──────────────────────────────────────────────────────
  function renderItems(cart) {
    var wrap = el('[data-ecd-items]');
    if (!wrap) return;

    // Leeg = geen echte artikelen (een losse verzendbescherming telt niet; die haalt
    // renderProtection meteen weg). Essential verbergt dan de announcement en de balk
    // en zet icoon, tekst en knop midden onder de kop.
    var real = cart.items.filter(function (i) { return !(protVariantId && i.variant_id === protVariantId); });
    root.classList.toggle('is-empty', !real.length);
    if (!real.length) {
      wrap.innerHTML =
        '<div class="ecd-empty">' +
        (CFG.emptyImage ? '<span class="ecd-empty-icon" aria-hidden="true" style="-webkit-mask-image:url(' + esc(CFG.emptyImage) + ');mask-image:url(' + esc(CFG.emptyImage) + ')"></span>' : '') +
        '<p>' + esc(t('empty', CFG.emptyText)) + '</p>' +
        '<a href="' + esc(ROOT) + 'collections/all">' + esc(t('emptyBtn', CFG.emptyButtonText)) + '</a>' +
        '</div>';
      return;
    }

    wrap.innerHTML = cart.items.map(function (item, index) {
      if (protVariantId && item.variant_id === protVariantId) return '';   // eigen blok in de footer
      var img = item.image
        ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="' + esc(item.product_title) + '">'
        : '';
      var line = index + 1;

      // Variant-keuze: alle varianten, uitverkochte disabled; onder de twee geen dropdown.
      var variantHtml = '';
      var variants = variantsFor(item);
      if (variants.length > 1) {
        var opts = variants.map(function (v) {
          var label = v.title + (v.available ? '' : ' — ' + t('soldOut'));
          return '<option value="' + v.id + '"' +
            (v.id === item.variant_id ? ' selected' : '') +
            (v.available ? '' : ' disabled') +
            '>' + esc(label) + '</option>';
        }).join('');
        variantHtml =
          '<div class="ecd-item-variant"><div class="ecd-item-variant-inner">' +
            '<select data-ecd-variant data-current="' + item.variant_id + '" data-line="' + line + '"' +
            ' aria-label="' + esc(t('ariaVariant')) + '">' + opts + '</select>' +
            '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M5.72 8.47a.75.75 0 0 1 1.06 0l3.47 3.47 3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z"/></svg>' +
          '</div></div>';
      }

      // Kortingslabel per regel, zoals Essential: de naam van de staffelkorting die
      // Shopify op DEZE regel toepaste (vertaald waar we 'm kennen).
      var namen = I18N.discountNames || {};
      var seenD = {};
      // Lumeure (eigenaar, okt 2026): de staffel staat ALLEEN onderaan bij 'Korting', niet per regel.
      var discHtml = [].filter(function (a) {
        var n = a.discount_application && a.discount_application.title;
        if (!n || !a.amount || seenD[n]) return false;
        seenD[n] = 1; return true;
      }).map(function (a) {
        var n = a.discount_application.title;
        return '<div class="ecd-item-discount">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M8.575 4.649a3.75 3.75 0 0 1 2.7-1.149h1.975a3.25 3.25 0 0 1 3.25 3.25v2.187a3.25 3.25 0 0 1-.996 2.34l-4.747 4.572a2.5 2.5 0 0 1-3.502-.033l-2.898-2.898a2.75 2.75 0 0 1-.036-3.852l4.254-4.417Zm4.425 3.351a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>' +
          '<span>' + esc(namen[n] || n) + '</span></div>';
      }).join('');

      // Prijs zoals Essential: doorgestreept de vanafprijs (of, zonder vanafprijs, de
      // prijs vóór korting) en daaronder in rood wat de klant echt betaalt — de
      // regelprijs NA de staffelkorting. Zonder enige korting alleen de rode prijs.
      var compareAt = compareAtFor(item);
      var paid = item.original_line_price;   // prijs vóór de staffel; de staffel staat onderaan
      var was = compareAt ? compareAt * item.quantity
              : (item.original_line_price > paid ? item.original_line_price : 0);
      var priceHtml = was
        ? '<div class="ecd-item-price-was">' + money(was) + '</div><div class="ecd-item-price-now">' + money(paid) + '</div>'
        : '<div class="ecd-item-price-now">' + money(paid) + '</div>';

      return '' +
        '<div class="ecd-item"><div class="ecd-item-frame"><div class="ecd-item-row">' +
          '<a class="ecd-item-image" href="' + esc(item.url) + '" tabindex="-1">' + img + '</a>' +
          '<div class="ecd-item-details">' +
            '<a class="ecd-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            discHtml + variantHtml +
          '</div>' +
          '<div class="ecd-item-side">' +
            '<div class="ecd-item-price">' + priceHtml + '</div>' +
            '<div class="ecd-item-actions">' +
              '<button type="button" class="ecd-item-remove" data-ecd-remove data-line="' + line + '" aria-label="' + esc(t('ariaRemove')) + '">' +
                '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M11.5 8.25C11.9142 8.25 12.25 8.58579 12.25 9V13.25C12.25 13.6642 11.9142 14 11.5 14C11.0858 14 10.75 13.6642 10.75 13.25V9C10.75 8.58579 11.0858 8.25 11.5 8.25Z" fill="currentColor"/><path d="M9.25 9C9.25 8.58579 8.91421 8.25 8.5 8.25C8.08579 8.25 7.75 8.58579 7.75 9V13.25C7.75 13.6642 8.08579 14 8.5 14C8.91421 14 9.25 13.6642 9.25 13.25V9Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.24994 5.25C7.24994 3.73122 8.48116 2.5 9.99994 2.5C11.5187 2.5 12.7499 3.73122 12.7499 5.25H15.75C16.1642 5.25 16.5 5.58579 16.5 6C16.5 6.41421 16.1642 6.75 15.75 6.75H14.9999L14.9998 12.2001C14.9998 13.8802 14.9997 14.7203 14.6728 15.362C14.3851 15.9265 13.9262 16.3854 13.3617 16.673C12.72 17 11.8799 17 10.1997 17H9.79999C8.11978 17 7.27968 17 6.63793 16.673C6.07343 16.3854 5.61448 15.9264 5.32687 15.3619C4.99989 14.7202 4.9999 13.8801 4.99994 12.1999L5.00005 6.75H4.25C3.83579 6.75 3.5 6.41421 3.5 6C3.5 5.58579 3.83579 5.25 4.25 5.25H7.24994ZM8.74994 5.25C8.74994 4.55964 9.30958 4 9.99994 4C10.6903 4 11.2499 4.55964 11.2499 5.25H8.74994ZM6.50007 6.75H13.4999L13.4998 12.2001C13.4998 13.0649 13.4986 13.6233 13.4639 14.0483C13.4305 14.4558 13.374 14.6068 13.3362 14.681C13.1924 14.9632 12.963 15.1927 12.6807 15.3365C12.6065 15.3743 12.4555 15.4308 12.048 15.4641C11.623 15.4988 11.0646 15.5 10.1997 15.5H9.79999C8.93513 15.5 8.37671 15.4988 7.95169 15.4641C7.54418 15.4308 7.3931 15.3743 7.31893 15.3365C7.03668 15.1927 6.80721 14.9632 6.6634 14.681C6.62561 14.6068 6.56909 14.4557 6.53581 14.0482C6.50109 13.6232 6.49994 13.0648 6.49995 12.1999L6.50007 6.75Z" fill="currentColor"/></svg>' +
              '</button>' +
              '<div class="ecd-qty">' +
                '<button type="button" data-ecd-qty="-1" data-line="' + line + '" aria-label="' + esc(t('ariaLess')) + '"' + (item.quantity <= 1 ? ' disabled' : '') + '>' +
                  '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"/></svg>' +
                '</button>' +
                '<span class="ecd-qty-value" aria-live="polite">' + item.quantity + '</span>' +
                '<button type="button" data-ecd-qty="1" data-line="' + line + '" aria-label="' + esc(t('ariaMore')) + '">' +
                  '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div></div></div>';
    }).join('');
  }

  function renderReward(cart) {
    var box = el('[data-ecd-reward]');
    if (!box || !TIERS.length) return;
    box.hidden = false;

    // De verzendbescherming telt NIET mee voor de staffel. Gecontroleerd gemeten
    // (27-08): 2 echte producten = 15% met én zonder bescherming; 1 echt product +
    // bescherming = geen korting. Shopify's kortingsregel kijkt dus naar de echte
    // producten, en de balk moet dat volgen — anders zou 'ie bij 2 producten +
    // bescherming de 20%-trede als behaald tonen terwijl de klant 15% krijgt.
    var count = cart.item_count;
    if (protVariantId) {
      cart.items.forEach(function (i) { if (i.variant_id === protVariantId) count -= i.quantity; });
    }
    // Producten buiten de staffel (Ellegems: de camel toe string, tag 'geen-staffel') tellen
    // ook niet mee — Shopify's korting slaat ze over, en Essential deed hetzelfde.
    var EXCL = String((CFG.reward && CFG.reward.exclude) || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
    if (EXCL.length) {
      cart.items.forEach(function (i) { if (EXCL.indexOf(i.product_id) >= 0) count -= i.quantity; });
    }
    var reached = TIERS.filter(function (t) { return count >= t.min; }).length;
    var next = TIERS[reached];

    // Vulling in gelijke segmenten per tier — zo staat de balk op 50% zodra de
    // eerste van twee tiers gehaald is, exact als de live drawer.
    var pct;
    if (!next) {
      pct = 100;
    } else {
      var prevMin = reached ? TIERS[reached - 1].min : 0;
      var within = (count - prevMin) / Math.max(next.min - prevMin, 1);
      pct = ((reached + Math.min(Math.max(within, 0), 1)) / TIERS.length) * 100;
    }
    el('[data-ecd-reward-fill]').style.width = pct.toFixed(2) + '%';

    var textEl = el('[data-ecd-reward-text]');
    if (next) {
      var remaining = next.min - count;
      var before = t('rewardBefore', CFG.reward.beforeText);
      textEl.innerHTML = String(before).replace(/\{remaining[^}]*\}/g, remaining);
      textEl.className = 'ecd-reward-text is-before';
    } else {
      var last = TIERS[TIERS.length - 1];
      var done = t('rewardDone', CFG.reward.completedText);
      textEl.innerHTML = String(done).replace(/\{name\}/g, esc(last.name));
      // Essential zet de gewone tekst van de 'behaald'-regel per taal anders: 500 in
      // nl/en, 400 in fr/pl. Zo staat het in de i18n-config (doneWeight).
      textEl.className = 'ecd-reward-text is-done';
      textEl.style.fontWeight = I18N.doneWeight || '';
    }

    var holder = el('[data-ecd-reward-milestones]');
    holder.innerHTML = TIERS.map(function (t, i) {
      var left = ((i + 1) / TIERS.length) * 100;
      // Eigenaar 27-08: de zwarte ring markeert BEHAALDE treden, zodat de klant
      // ziet waar 'ie staat. Trede i is behaald zodra i < reached (reached telt
      // hoeveel treden gehaald zijn, en telt de verzendbescherming niet mee).
      var isReached = i < reached;
      return '<div class="ecd-reward-milestone" style="left:' + left + '%">' +
        '<div class="ecd-reward-icon' + (isReached ? ' is-reached' : '') + '">' +
          // Exact het icoon uit de Essential-drawer: kortingsbadge (gekartelde cirkel
          // met procentteken), massief zwart. Het icoon zelf is voor BEIDE treden
          // gelijk (net als bij Essential); behaald/niet-behaald zie je aan de
          // balkvulling EN aan de zwarte ring (.is-reached).
          '<svg viewBox="0 0 20 20" aria-hidden="true">' +
            '<path fill-rule="evenodd" fill="currentColor" d="M11.527 3.327c-.6-1.306-2.455-1.306-3.054 0a1.68 1.68 0 0 1-2.112.874c-1.347-.5-2.66.813-2.16 2.16a1.68 1.68 0 0 1-.874 2.112c-1.306.6-1.306 2.455 0 3.054a1.68 1.68 0 0 1 .874 2.112c-.5 1.347.813 2.659 2.16 2.16a1.68 1.68 0 0 1 2.112.874c.6 1.306 2.455 1.306 3.054 0a1.68 1.68 0 0 1 2.112-.874c1.347.499 2.66-.813 2.16-2.16a1.68 1.68 0 0 1 .874-2.112c1.306-.6 1.306-2.455 0-3.054a1.68 1.68 0 0 1-.874-2.112c.5-1.347-.813-2.66-2.16-2.16a1.68 1.68 0 0 1-2.112-.874Zm-2.527 4.923a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.53.53-4 4a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 1 1 1.06 1.06Zm.47 3.47a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>' +
          '</svg>' +
        '</div>' +
        '<div class="ecd-reward-label">' + esc(t.name) + '</div>' +
        '</div>';
    }).join('');
  }

  function renderTotals(cart) {
    el('[data-ecd-subtotal]').textContent = money(cart.total_price);
    var countEl = el('[data-ecd-count]');
    // De verzendbescherming is geen artikel: niet meetellen in "Winkelwagen • N".
    var shown = cart.item_count;
    if (protVariantId) cart.items.forEach(function (i) { if (i.variant_id === protVariantId) shown -= i.quantity; });
    if (countEl) countEl.textContent = shown;

    // Kortingsrij: puur weergave van wat Shopify zelf meldt.
    var wrap = el('[data-ecd-discount-wrap]');
    if (!wrap) return;
    // Twee soorten besparing bij elkaar: de staffel-/codekorting die Shopify toekent
    // EN het verschil tussen vanafprijs en actuele prijs.
    var apps = cart.cart_level_discount_applications || [];
    var compareSavings = 0;
    cart.items.forEach(function (i) {
      var c = compareAtFor(i);
      if (c) compareSavings += (c - i.original_price) * i.quantity;
    });
    var total = (cart.total_discount || 0) + compareSavings;
    var row = el('[data-ecd-discount-row]');
    wrap.hidden = false;                       // Essential laat de lege rij (24px) altijd staan
    if (!total) { if (row) row.hidden = true; return; }
    if (row) row.hidden = false;

    var tags = apps.map(function (a) { return a.title; }).filter(Boolean);
    // Een staffelkorting kent Shopify per REGEL toe, niet op mandniveau. Zonder deze
    // lus blijft alleen het 'aanbieding'-label over en zie je nooit WELKE korting je kreeg.
    cart.items.forEach(function (i) {
      (i.discounts || []).forEach(function (d) {
        if (d.title && tags.indexOf(d.title) < 0) tags.push(d.title);
      });
    });
    (cart.discount_codes || []).forEach(function (d) {
      if (d.applicable && tags.indexOf(d.code) < 0) tags.push(d.code);
    });
    if (compareSavings) tags.unshift(t('sale'));
    // Shopify levert de kortingsnaam in één taal (de titel van de korting). Per markt
    // vertalen waar we 'm kennen; een onbekende naam tonen we onvertaald in plaats van te raden.
    var namen = I18N.discountNames || {};
    tags = tags.map(function (x) { return namen[x] || x; });
    // In een vaste container schrijven; outerHTML vervangen liet bij elke render
    // een extra label achter (Shopify meldt dezelfde korting per regel).
    var seen = {};
    var unique = tags.filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; });
    el('[data-ecd-discount-tags]').innerHTML = unique.map(function (x) {
      return '<span class="ecd-discount-tag">' + esc(x) + '</span>';
    }).join('');
    el('[data-ecd-discount-amount]').innerHTML = '<span>-</span><span>' + esc(money(total)) + '</span>';
  }

  function renderUpsells(cart) {
    var box = el('[data-ecd-upsells]');
    if (!box || !(CFG.upsells && CFG.upsells.enabled)) return;
    if (upsellsLoaded || !cart.items.length) return;
    upsellsLoaded = true;

    // Upsell per categorie (thema-template collection.ecd-upsell): bij een jurk een tas,
    // schoen of jas. Lege uitkomst of fout -> terugvallen op Shopify-aanbevelingen.
    var pid = cart.items[0].product_id;
    var realItem = cart.items.filter(function (i) { return i.variant_id !== protVariantId; })[0];
    if (realItem) pid = realItem.product_id;
    function related() {
      return fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=' + (CFG.upsells.limit || 10) + '&intent=related')
        .then(function (r) { return r.json(); });
    }
    fetch(ROOT + 'collections/all?view=ecd-upsell&_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) { return (data.products && data.products.length) ? data : related(); })
      .catch(related)
      .then(function (data) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });
        var items = (data.products || []).filter(function (p) { return !inCart[p.id]; });
        if (!items.length) return;
        box.hidden = false;
        el('[data-ecd-upsell-track]').innerHTML = items.map(function (p) {
          var v = p.variants && p.variants[0];
          if (!v) return '';
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var was = (v.compare_at_price && v.compare_at_price > v.price)
            ? '<span class="ecd-upsell-price-was">' + money(v.compare_at_price) + '</span>' : '';
          return '<div class="ecd-upsell-card"><div class="ecd-upsell-product">' +
            '<a class="ecd-upsell-img" href="' + esc(p.url || ('/products/' + p.handle)) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="ecd-upsell-content">' +
              '<a class="ecd-upsell-name" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
              (p.variants && p.variants.length > 1
                ? '<div class="ecd-upsell-variant"><select data-ecd-upsell-variant aria-label="' + esc(t('ariaVariant')) + '">' +
                  p.variants.map(function (vv) {
                    return '<option value="' + vv.id + '"' + (vv.available ? '' : ' disabled') + '>' + esc(vv.title) + '</option>';
                  }).join('') + '</select></div>'
                : '') +
              '<div class="ecd-upsell-price">' +
                '<span class="ecd-upsell-price-now">' + money(v.price) + '</span>' + was +
              '</div>' +
            '</div>' +
            '<button type="button" class="ecd-upsell-add" data-ecd-upsell-add="' + v.id + '">' +
              '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
              '<span>' + esc(t('upsellBtn', CFG.upsells.buttonText)) + '</span>' +
            '</button>' +
          '</div></div>';
        }).join('');
      })
      .catch(function () { /* aanbevelingen zijn optioneel: stil falen */ });
  }

  // ── Verzendbescherming ────────────────────────────────────────────
  // Eigen Shopify-product als gewone cart-regel. Staat standaard aan; de klant kan
  // 'm uitzetten. Eén keer per sessie automatisch toevoegen — zet de klant 'm uit,
  // dan blijft dat zo (anders vecht de drawer met de bezoeker).
  var PROT = CFG.protection || {};
  var protVariantId = PROT.variantId ? parseInt(PROT.variantId, 10) : 0;
  var protBusy = false;
  var protAutoAdded = false;      // grendel: één automatische toevoeging per paginabezoek
  var PROT_OPTOUT = 'ecdProtectionOptOut';

  function protLine(cart) {
    if (!protVariantId) return null;
    var idx = -1, line = null;
    cart.items.forEach(function (i, n) { if (i.variant_id === protVariantId) { idx = n + 1; line = i; } });
    return line ? { line: idx, item: line } : null;
  }

  function optedOut() {
    try { return sessionStorage.getItem(PROT_OPTOUT) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try { v ? sessionStorage.setItem(PROT_OPTOUT, '1') : sessionStorage.removeItem(PROT_OPTOUT); } catch (e) {}
  }

  function renderProtection(cart) {
    var wrap = el('[data-ecd-protection-wrap]');
    if (!wrap || !protVariantId) return;

    // Alleen tonen als er iets te beschermen valt.
    var hasRealItems = cart.items.some(function (i) { return i.variant_id !== protVariantId; });
    if (!hasRealItems) {
      wrap.hidden = true;
      // Lege cart = nieuwe cart: uitzetten gold alleen voor de vorige, dus weer standaard aan.
      setOptOut(false); protAutoAdded = false;
      // Laatste echte product weg: de bescherming mag niet in z'n eentje blijven staan
      // (anders rekent de klant €3,95 af voor niets). Opt-out blijft onaangeroerd, zodat
      // een volgend product 'm weer krijgt zoals de klant het had ingesteld.
      var lone = protLine(cart);
      if (lone && !protBusy) {
        protBusy = true;
        fetch(ROOT + 'cart/change.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lone.line, quantity: 0 }) })
          .then(function () { protBusy = false; protAutoAdded = false; refresh(); })
          .catch(function () { protBusy = false; });
      }
      return;
    }
    wrap.hidden = false;

    var found = protLine(cart);
    var present = !!found;

    // Twee gelijktijdige refreshes zagen allebei 'nog niet aanwezig' en voegden 'm
    // allebei toe -> aantal 2. Meer dan één is nooit gewenst: terugzetten naar 1.
    if (found && found.item.quantity > 1 && !protBusy) {
      protBusy = true;
      fetch(ROOT + 'cart/change.js', { method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: found.line, quantity: 1 }) })
        .then(function () { protBusy = false; refresh(); })
        .catch(function () { protBusy = false; });
      return;
    }
    el('[data-ecd-protection-name]').textContent = t('protName');
    el('[data-ecd-protection-desc]').innerHTML =
      esc(t('protDesc')) + ' <span class="ecd-protection-price">' +
      esc(money(PROT.marketPrice || PROT.price || 395)) + '</span>';
    var tog = el('[data-ecd-protection-toggle]');
    tog.setAttribute('aria-checked', present ? 'true' : 'false');
    tog.disabled = protBusy;

    // Standaard aan: één keer toevoegen, tenzij de klant 'm eerder uitzette.
    if (PROT.defaultOn && !present && !optedOut() && !protBusy && !protAutoAdded) {
      protAutoAdded = true;   // synchroon zetten, vóór de fetch
      protBusy = true;
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: protVariantId, quantity: 1 }] })
      }).then(function () { protBusy = false; refresh(); })
        .catch(function () { protBusy = false; });
    }
  }

  function toggleProtection() {
    if (!protVariantId || protBusy) return;
    protBusy = true;
    root.classList.add('is-busy');
    return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var found = protLine(cart);
      if (found) {
        setOptOut(true);
        protAutoAdded = true;   // niet automatisch terugzetten na uitzetten
        return fetch(ROOT + 'cart/change.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: found.line, quantity: 0 }) });
      }
      setOptOut(false);
      return fetch(ROOT + 'cart/add.js', { method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: protVariantId, quantity: 1 }] }) });
    }).then(function () { protBusy = false; return refresh(); })
      .then(function () { root.classList.remove('is-busy'); })
      .catch(function () { protBusy = false; root.classList.remove('is-busy'); });
  }

  // ── Cart-verkeer ──────────────────────────────────────────────────
  function refresh() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return loadProducts(cart).then(function () { return cart; });
      })
      .then(function (cart) {
        renderItems(cart); renderReward(cart); renderTotals(cart); renderUpsells(cart);
        renderProtection(cart);
        announceCartChange(cart);
        var btn = el('[data-ecd-checkout]');
        // Essential laat de afrekenknop ook bij een lege winkelwagen gewoon staan.
        return cart;
      });
  }

  // Cart-events uitzenden waar thema's/apps op luisteren. Bewust GEEN eigen
  // pixel-events publiceren: op deze store vuurt ook de gewone productpagina-knop
  // geen product_added_to_cart, dus dat zou de tracking scheeftrekken i.p.v. herstellen.
  // De aankoop-conversie loopt sowieso via Shopify's checkout-pixels; de afrekenknop
  // post naar /cart met name="checkout", exact de standaardroute.
  function announceCartChange(cart) {
    ['cart:updated', 'ecd:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart } }));
    });
    // Impulse-header: het bolletje toont alleen echte artikelen, niet de verzendbescherming.
    var shown = cart.item_count;
    if (protVariantId) cart.items.forEach(function (i) { if (i.variant_id === protVariantId) shown -= i.quantity; });
    document.querySelectorAll('.u-cart-link-count, .cart-link__bubble-num').forEach(function (b) { b.textContent = shown; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', shown > 0); });
    // Prestige-header: <cart-count> en <cart-dot>
    document.querySelectorAll('cart-count').forEach(function (b) { try { b.itemCount = shown; } catch (e) { b.textContent = shown; } });
    document.querySelectorAll('cart-dot').forEach(function (b) { b.classList.toggle('is-visible', shown > 0); });
  }

  function change(body) {
    root.classList.add('is-busy');
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function () { return refresh(); })
      .catch(function () { return refresh(); })
      .then(function (cart) { root.classList.remove('is-busy'); announceCartChange(cart); return cart; });
  }

  // ── Events ────────────────────────────────────────────────────────
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ecd-close],[data-ecd-remove],[data-ecd-qty],[data-ecd-upsell-add],[data-ecd-upsell-prev],[data-ecd-upsell-next],[data-ecd-protection-toggle]');
    if (!t) return;

    if (t.hasAttribute('data-ecd-protection-toggle')) { e.preventDefault(); return toggleProtection(); }

    if (t.hasAttribute('data-ecd-close')) { e.preventDefault(); return close(); }

    if (t.hasAttribute('data-ecd-remove')) {
      e.preventDefault();
      return change({ line: parseInt(t.dataset.line, 10), quantity: 0 });
    }

    if (t.hasAttribute('data-ecd-qty')) {
      e.preventDefault();
      var row = t.closest('.ecd-qty');
      var current = parseInt(row.querySelector('.ecd-qty-value').textContent, 10) || 1;
      var next = current + parseInt(t.getAttribute('data-ecd-qty'), 10);
      return change({ line: parseInt(t.dataset.line, 10), quantity: Math.max(next, 0) });
    }

    if (t.hasAttribute('data-ecd-upsell-add')) {
      e.preventDefault();
      root.classList.add('is-busy');
      var upId = parseInt(selectedVariantFor(t), 10);
      // Upsell-meting: verborgen regel-eigenschap (staat in de order) + klantgebeurtenis.
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var nm = t.closest('.ecd-upsell-product'); nm = nm && nm.querySelector('.ecd-upsell-name');
          Shopify.analytics.publish('upsell_added', { source: 'cart-drawer', variant_id: upId, product_title: nm ? nm.textContent.trim() : null });
        }
      } catch (err) {}
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: upId, quantity: 1, properties: { _upsell: 'cart-drawer' } }] })
      }).then(function () { upsellsLoaded = false; return refresh(); })
        .then(function () { root.classList.remove('is-busy'); });
    }

    var track = el('[data-ecd-upsell-track]');
    if (track && t.hasAttribute('data-ecd-upsell-prev')) { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); }
    if (track && t.hasAttribute('data-ecd-upsell-next')) { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); }
  });

  // Shopify's /cart/change.js KAN geen variant omwisselen — 'id' dient daar om de
  // REGEL aan te wijzen, niet om er een andere variant van te maken. De oude aanroep
  // hier deed dus niets (en gooide het aantal bovendien terug naar 1). Een swap is
  // 'oude variant naar 0 + nieuwe variant erbij', en dat kan /cart/update.js in EEN
  // call — belangrijk, want twee losse calls laten de cart even op 1 product staan
  // en dat zou de staffelkorting zichtbaar laten wegspringen.
  function swapVariant(sel) {
    var oldId = parseInt(sel.getAttribute('data-current'), 10);
    var newId = parseInt(sel.value, 10);
    if (!newId || newId === oldId) return Promise.resolve();
    root.classList.add('is-busy');
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var moving = 0, already = 0;
        cart.items.forEach(function (i) {
          if (i.variant_id === oldId) moving += i.quantity;
          if (i.variant_id === newId) already += i.quantity;
        });
        if (!moving) return null;                    // regel is intussen al weg
        var updates = {};
        updates[oldId] = 0;
        // Optellen, niet overschrijven: zit de nieuwe maat al in de cart, dan moet
        // die niet stilletjes terugvallen naar het aantal van de oude regel.
        updates[newId] = already + moving;
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      // Mislukt de wissel (net uitverkocht, netwerk), dan hertekent refresh() uit de
      // ECHTE cart en springt de dropdown vanzelf terug naar de variant die er staat.
      .then(function () { return refresh(); })
      .catch(function () { return refresh(); })
      .then(function (cart) { root.classList.remove('is-busy'); return cart; });
  }

  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ecd-variant]');
    if (!sel) return;
    swapVariant(sel);
  });

  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // Elke link naar /cart opent de drawer i.p.v. de cartpagina.
  // Prestige koppelt [aria-controls="cart-drawer"] aan z'n eigen (verborgen) drawer; die
  // zou de pagina vergrendelen. Daarom in de capture-fase, vóór Prestige, onderscheppen.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [aria-controls="cart-drawer"], [data-ecd-open]');
    if (!link || root.contains(link)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // Openen zodra er iets aan de winkelwagen is toegevoegd (theme-agnostisch:
  // we onderscheppen de fetch naar /cart/add).
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = (typeof url === 'string') ? url : (url && url.url) || '';
    var result = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?/.test(href)) {
      result.then(function (res) {
        if (res && res.ok === false) return;   // 422 (uitverkocht/max): Impulse toont zelf de fout
        if (/\/cart\/add/.test(href)) { upsellsLoaded = false; open(); }
        else if (root.classList.contains('is-open')) refresh();
      }).catch(function () {});
    }
    return result;
  };

  window.ecDrawer = { open: open, close: close, refresh: refresh };

  // Op /cart loopt +/− en verwijderen via een gewone paginalading, buiten de
  // fetch-wrapper om. Bij het laden daarom één keer nakijken: de bescherming staat er
  // hooguit één keer in, en nooit in z'n eentje.
  if (protVariantId) {
    origFetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var f = protLine(cart);
        if (!f) return;
        var real = cart.items.some(function (i) { return i.variant_id !== protVariantId; });
        var want = real ? 1 : 0;
        if (f.item.quantity === want) return;
        return origFetch(ROOT + 'cart/change.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: f.line, quantity: want }) })
          .then(function () { if (/\/cart\/?$/.test(location.pathname)) location.reload(); });
      })
      .catch(function () {});
  }

  // Impulse: theme.js maakt alleen een eigen CartDrawer als cartType 'drawer' is; de
  // snippet zet cartType vóór theme.js op 'ecd', dus die drawer bestaat niet en de
  // pagina springt ook niet naar /cart (dat doet Impulse alleen bij 'page'). Wat
  // Impulse nog uitzendt, sturen we hierheen: ajaxProduct:added na een toevoeging
  // (de fetch-wrapper opent ook al; open() twee keer is onschuldig), en cart:open /
  // cart:close die andere thema-onderdelen gebruiken.
  document.addEventListener('ajaxProduct:added', function (e) {
    // Bij een fout (422) stuurt Impulse hetzelfde event zonder product mee.
    if (e && e.detail && e.detail.product) { upsellsLoaded = false; open(); }
  });
  document.addEventListener('cart:open', function () { open(); });
  document.addEventListener('cart:close', function () { close(); });
})();

